import React, { useCallback, useEffect, useState, useTransition } from 'react';
import { settings } from '../../settings';
import { DidomiSDK } from '@didomi/react';
import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';
import { useExternalScript } from '../common/hooks';
import { useLocation } from 'react-router-dom';

export const didomiEnabled = !!settings.DIDOMI_API_KEY;
let scriptsInitialised = false;

const dispatchPageViewEvent = () => document.dispatchEvent(new CustomEvent('page_view'));
const useCxenseScript = () => {
  const state = useExternalScript(settings.ADS_CXENSE_SCRIPT);
  const location = useLocation();
  useEffect(() => {
    document.addEventListener('cxLoaded', dispatchPageViewEvent);
    return () => {
      document.removeEventListener('cxLoaded', dispatchPageViewEvent);
    };
  }, []);
  useEffect(() => {
    if (state === 'ready') {
      dispatchPageViewEvent();
    }
  }, [location]);
};

const consentStatus = (d) => d && d.getUserConsentStatusForAll().purposes;
export const ConsentScripts = () => {
  const [didomiStatus, setDidomiStatus] = useState(null);
  const [didomi, setDidomi] = useState(null);
  const setTransition = useTransition()[1];
  useCxenseScript();

  const InitializeScripts = () => {
    useEffect(() => {
      if (didomiStatus.disabled.length === 0 && didomiStatus.enabled.length > 0) {
        ReactGA.initialize(settings.GA_TRACKING_ID);
        TagManager.initialize({ gtmId: settings.GTM_CODE });
        scriptsInitialised = true;
      }
    }, [didomiStatus.disabled.length, didomiStatus.enabled.length]);
    return null;
  };

  const onDidomiNoticeHidden = useCallback(() => {
    setDidomiStatus(consentStatus(didomi));
  }, [didomi]);

  const onDidomiReady = useCallback((d) => {
    setTransition(() => {
      setDidomi(d);
      if (!d.notice.isVisible()) {
        setDidomiStatus(consentStatus(d));
      }
    });
  }, []);

  useEffect(() => {
    setTransition(() => {
      if (!didomiEnabled) {
        setDidomiStatus({ enabled: [], disabled: [] });
      }
    });
  }, []);

  return (
    <>
      {didomiStatus && !scriptsInitialised && <InitializeScripts />}
      {didomiEnabled && (
        <DidomiSDK
          apiKey={settings.DIDOMI_API_KEY}
          onNoticeHidden={onDidomiNoticeHidden}
          onReady={onDidomiReady}
          onConsentChanged={() => window.location.reload()}
        />
      )}
    </>
  );
};
